import { Box, Grid } from '@mui/material';

import KpiCard from '../../../../components/ui/kpiCard';

export function RetentionKpis() {
  return (
    <Box>
<Grid container spacing={3} mb={4}>
      <Grid item xs={6} sm={6} md={3}>
        <KpiCard title="Taux de réachat" value="42%" />
      </Grid>
      <Grid item xs={6} sm={6} md={3}>
        <KpiCard title="Clients récurrents" value="620" />
      </Grid>
      <Grid item xs={6} sm={6} md={3}>
        <KpiCard title="Événements / client" value="2,8" />
      </Grid>
      <Grid item xs={6} sm={6} md={3}>
        <KpiCard title="Clients VIP" value="85" />
      </Grid>
    </Grid>
    </Box>
    
  );
}
